import { PreloadedQuery } from 'react-relay';

import { Milestone } from '@townsquare/milestones';
import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { expVal } from '@townsquare/stat-sig';
import { getBooleanConfig } from '@townsquare/stat-sig/config';
import { PROJECTS_NATIVE_INTEGRATION_WITH_JIRA } from '@townsquare/stat-sig/experiments';

import ProjectViewAsideQuery, {
	type ProjectViewAsideQuery as ProjectViewAsideQueryType,
} from '../components/__generated__/ProjectViewAsideQuery.graphql';

export const projectViewAsideResource: RouteResource<
	PreloadedQuery<ProjectViewAsideQueryType, Record<string, unknown>>
> = createRelayResource<ProjectViewAsideQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const areMilestonesEnabled = getBooleanConfig('townsquare_enable_milestones_in_sidebar');
		const isProjectNativeIntegrationEnabled =
			expVal(PROJECTS_NATIVE_INTEGRATION_WITH_JIRA, 'releaseVersion', -1) >= 0;

		if (areMilestonesEnabled) {
			Milestone.preload();
		}

		return {
			query: ProjectViewAsideQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				workspaceId: context.workspace?.globalId,
				areMilestonesEnabled,
				cloudId: context.workspace?.cloudId,
				isProjectNativeIntegrationEnabled,
			},
		};
	},
});
